import React from 'react';
import { View, Text, TouchableOpacity, StyleSheet, ScrollView, Dimensions, Image } from 'react-native';
import { useTheme } from '../contexts/ThemeContext';
import Footer from '../components/Footer';
import { useNavigation } from '@react-navigation/native';

const ToolsHomeScreen = () => {
  const { colors } = useTheme();
  const navigation = useNavigation();
  const width = Dimensions.get('window').width;

  const tools = [
    {
      id: 'invoice',
      title: 'Invoice Generator',
      description: 'Create GST-compliant invoices and export as PDF.',
      icon: require('../../assets/icons/finance.png'),
      color: '#10B981',
      screen: 'InvoiceGenerator',
    },
    {
      id: 'quotation',
      title: 'Quotation Maker',
      description: 'Craft professional quotations with live preview and totals.',
      icon: require('../../assets/icons/money.png'),
      color: '#3B82F6',
      screen: 'QuotationMaker',
    },
    // Add more tools here later
  ];

  const styles = StyleSheet.create({
    container: { flex: 1, backgroundColor: '#f8fafc' },
    scrollView: { flex: 1 },
    heroSection: {
      backgroundColor: '#4f46e5',
      paddingVertical: 60,
      paddingHorizontal: 20,
      alignItems: 'center',
      marginBottom: 40,
    },
    heroTitle: {
      fontSize: width > 768 ? 48 : width > 480 ? 36 : 28,
      fontWeight: 'bold',
      color: 'white',
      textAlign: 'center',
      marginBottom: 10,
    },
    heroSubtitle: {
      fontSize: width > 768 ? 20 : width > 480 ? 18 : 16,
      color: '#e0e7ff',
      textAlign: 'center',
      marginBottom: 15,
    },
    heroDescription: {
      fontSize: 16,
      color: '#c7d2fe',
      textAlign: 'center',
      maxWidth: 600,
      lineHeight: 24,
    },
    gridWrapper: { paddingHorizontal: 20, marginBottom: 60 },
    grid: {
      flexDirection: 'row',
      flexWrap: 'wrap',
      justifyContent: 'space-around',
      paddingHorizontal: 10,
      maxWidth: 1200,
      alignSelf: 'center',
    },
    card: {
      backgroundColor: 'white',
      borderRadius: 16,
      padding: 16,
      width: width > 1024 ? '30%' : width > 768 ? '40%' : width > 480 ? '90%' : '95%',
      minWidth: width > 768 ? 250 : width > 480 ? 220 : 280,
      minHeight: 160,
      shadowColor: '#000',
      shadowOffset: { width: 0, height: 4 },
      shadowOpacity: 0.1,
      shadowRadius: 12,
      elevation: 6,
      alignItems: 'center',
      justifyContent: 'center',
      marginBottom: 16,
      borderWidth: 1,
      borderColor: '#f1f5f9',
    },
    cardIconContainer: {
      width: 64,
      height: 64,
      borderRadius: 32,
      justifyContent: 'center',
      alignItems: 'center',
      marginBottom: 16,
    },
    cardIcon: { width: 32, height: 32 },
    cardTitle: { fontSize: 18, fontWeight: 'bold', color: '#1f2937', textAlign: 'center', marginBottom: 8 },
    cardDescription: { fontSize: 13, color: '#6b7280', textAlign: 'center', lineHeight: 18, paddingHorizontal: 8 },
    cardButton: { marginTop: 12, paddingVertical: 10, paddingHorizontal: 14, borderRadius: 8 },
    cardButtonText: { color: '#fff', fontWeight: '600' },
  });

  const renderToolCard = (tool) => (
    <TouchableOpacity
      key={tool.id}
      style={[styles.card, { backgroundColor: tool.color + '15' }]}
      onPress={() => navigation.navigate(tool.screen)}
      activeOpacity={0.85}
    >
      <View style={[styles.cardIconContainer, { backgroundColor: tool.color + '25' }]}> 
        <Image source={tool.icon} style={styles.cardIcon} resizeMode="contain" />
      </View>
      <Text style={styles.cardTitle}>{tool.title}</Text>
      <Text style={styles.cardDescription}>{tool.description}</Text>
      <View style={[styles.cardButton, { backgroundColor: tool.color }]}> 
        <Text style={styles.cardButtonText}>Open</Text>
      </View>
    </TouchableOpacity>
  );

  return (
    <View style={styles.container}>
      <ScrollView style={styles.scrollView} showsVerticalScrollIndicator={false}>
        <View style={styles.heroSection}>
          <Text style={styles.heroTitle}>Tools</Text>
          <Text style={styles.heroSubtitle}>Your Complete Business Toolkit</Text>
          <Text style={styles.heroDescription}>Create invoices, quotations and more with our handy tools</Text>
        </View>
        <View style={styles.gridWrapper}>
          <View style={styles.grid}>
            {tools.map((t) => renderToolCard(t))}
          </View>
        </View>
      </ScrollView>
      <Footer />
    </View>
  );
};

export default ToolsHomeScreen;